// covered-by: frontends/carrie/src/ask-v2/review/__tests__/useAskPunttReview.test.tsx
import { useQuery } from "@tanstack/react-query";

import { getAskPunttReview } from "../services/reviews";

export const askV2ReviewKeys = {
  all: ["ask-v2-review"] as const,
  detail: (reviewId: string) =>
    [...askV2ReviewKeys.all, "detail", reviewId] as const,
};

export function useAskPunttReview(
  reviewId: string | null | undefined,
  options?: { enabled?: boolean },
) {
  const enabled = (options?.enabled ?? true) && !!reviewId;
  return useQuery({
    queryKey: askV2ReviewKeys.detail(reviewId ?? ""),
    queryFn: () => getAskPunttReview(reviewId!),
    enabled,
  });
}
